const formatDatesSet = (startDate,endDate,i18n) => {
	let formatedDate = '';

	if(startDate){
		const startDateObj = new Date(startDate);
		const start_d = String(startDateObj.getUTCDate()).padStart(2, '0');
		const start_m = String(startDateObj.getUTCMonth() + 1).padStart(2, '0');
		const start_y = startDateObj.getUTCFullYear();
		const startMonthName = startDateObj.toLocaleString(i18n.language+'-ca', { month: 'short' });

		if(endDate){
			const endDateObj = new Date(endDate);
			const end_d = String(endDateObj.getUTCDate()).padStart(2, '0');
			const end_m = String(endDateObj.getUTCMonth() + 1).padStart(2, '0');
			const end_y = endDateObj.getUTCFullYear();
			const endMonthName = endDateObj.toLocaleString(i18n.language+'-ca', { month: 'short' });

			if(i18n.language === 'fr'){
				if(start_m === end_m && start_y === end_y){
					formatedDate = start_d + ' au ' + end_d + ' ' + startMonthName + ' ' + end_y;
				} else {
					if(start_y === end_y){
						formatedDate = start_d + ' ' + startMonthName + ' au ' + end_d + ' ' + endMonthName + ' ' + end_y;
					} else {
						formatedDate = start_d + ' ' + startMonthName + ' ' + start_y + ' au ' + end_d + ' ' + endMonthName + ' ' + end_y;
					}
				}
			} else {
				if(start_m === end_m && start_y === end_y){
					formatedDate = startMonthName + ' ' + start_d + ' to ' + end_d + ' ' + end_y;
				} else {
					if(start_y === end_y){
						formatedDate = startMonthName + ' ' + start_d + ' to ' + endMonthName + ' ' + end_d + ' ' + end_y;
					} else {
						formatedDate = startMonthName + ' ' + start_d + ' ' + start_y + ' to ' + endMonthName + ' ' + end_d + ' ' + end_y;
					}
				}
			}
		} else {
			if(i18n.language === 'fr'){
				formatedDate = start_d + ' ' + startMonthName; //+ ' ' + startDateObj.getUTCHours()+"h"+startDateObj.getUTCMinutes();
			} else {
				formatedDate = startMonthName + ' ' + start_d; //+ ' ' + startDateObj.getTime()+":"+startDateObj.getUTCMinutes();
			}
		}
	}

	return formatedDate;
}

export default formatDatesSet;
